// Read-only lookups served by PostgREST (data.sksis.ca). The DreamFactory-era
// write and file-download methods were removed — no host serves that API anymore.

import { pgSelect, pgEq } from './postgrest';

interface SoilPitResponse {
  soil_pits_id: string;
}

export class PointService {
  async getSoilPitId(sk_point_id: string): Promise<SoilPitResponse> {
    try {
      const { resource } = await pgSelect<SoilPitResponse>(
        'sk_point_data',
        `${pgEq('id', sk_point_id)}&select=soil_pits_id`,
      );
      if (!resource[0]) throw new Error('Failed to fetch soil pit ID');
      return resource[0];
    } catch (error) {
      console.error('Error fetching soil pit ID:', error);
      throw error;
    }
  }

  async getPolygonComponents(polygonId: string): Promise<any> {
    try {
      return await pgSelect('polygon_components', pgEq('poly_id', polygonId));
    } catch (error) {
      console.error('Error fetching polygon components:', error);
      throw error;
    }
  }

  async getSoilPitInfo(soilPitId: string): Promise<any> {
    try {
      // Callers expect a bare record object, not the { resource } wrapper.
      const { resource } = await pgSelect('soil_pits', pgEq('id', soilPitId));
      if (!resource[0]) throw new Error('Failed to fetch soil pit info');
      return resource[0];
    } catch (error) {
      console.error('Error fetching soil pit info:', error);
      throw error;
    }
  }

  async getSoilPitHorizonInfo(soilPitId: string): Promise<any> {
    try {
      return await pgSelect(
        'soil_pits_horizons',
        `${pgEq('soil_pits_id', soilPitId)}&order=id.asc`,
      );
    } catch (error) {
      console.error('Error fetching soil pit horizon info:', error);
      throw error;
    }
  }
}

export const pointService = new PointService();
